import { defineField, defineType } from 'sanity'

import getPageInfo, { seoGroup } from '../../objects/pageInfo'
import { PageBlockTypes } from '../../pageBlocks'

export default defineType({
  title: 'Replacement Wheel',
  name: 'replacementWheel',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      group: 'content',
    }),
    defineField({
      title: 'Return Shipping Text',
      name: 'returnShippingText',
      type: 'string',
      group: 'content',
    }),
    defineField({
      title: 'Add To Cart Text',
      name: 'addToCartText',
      type: 'string',
      group: 'content',
    }),
    defineField({
      title: 'Page blocks',
      name: 'pageBlocks',
      type: 'array',
      of: [...PageBlockTypes],
      group: 'content',
    }),
    getPageInfo({ path: 'replacementProgram', lockCanonical: true }),
  ],
  preview: {
    select: {
      pageInfo: 'pageInfo',
    },
    prepare(selection) {
      const { title = 'New Page', description: subtitle = '' } =
        selection.pageInfo || {}
      return {
        title,
        subtitle,
      }
    },
  },
})